import React from 'react';
import { Link } from 'react-router-dom';

let  emergencyPopup;
if (typeof window !== 'undefined') {
 emergencyPopup = new CustomEvent("emergency");
}

const HeroSection = (props) => {


    // function to redner the content for the hero section on homepage page, about us and contact us page 
    const __renderHeroDescription = (type) => {
        switch (type) {
            case 'homepage': { // homepage hero section content
                return (
                    <>
                        <h2 className='description text-normal white col-12 col-md-8 col-lg-6'>{props?.description}</h2>
                        <Link className="button herobutton" to="/get-advice/questions" aria-label="Get started with housing questions">Find help now</Link>
                        <p className='sub-description col-12 col-md-8 col-lg-5 fadeWhite'>If you think it is an emergency <button type="button" aria-label="Open emergency help information" className='fw-bold btn-link' onClick={(e) => { e.preventDefault(); if(typeof window !== 'undefined'){ window.dispatchEvent(emergencyPopup)} }} style={{ cursor: 'pointer', border: 'none', background: 'none', padding: 0, color: 'inherit', textDecoration: 'underline' }}>Find help now</button></p>
                    </>
                )
            }
                break;
            case 'about': {
                return (
                    <>
                        <p className='description text-normal white col-12 col-md-6 col-lg-6'>“My Housing Issue” Gateway has been developed by the TDS Charitable Foundation to help tenants navigate their options when they have a housing issue.  </p>
                        <p className='description text-normal white col-12 col-md-6 col-lg-6 mb-4'>The TDS Charitable Foundation is on a mission to raise standards in the private rented sector.</p>
                        {/* <p className='description text-normal white col-12 col-md-6 col-lg-6 mb-1'>We deliver our mission by awarding grants to organisations, conducting research, and providing educational information to tenants and landlords.</p> */}
                    </>
                )
            }
            case 'privacy': {
                return (
                    <>
                        <h3 className='description title white col-12 col-md-7 col-lg-5'>Want more information about the TDS Charitable Foundation?</h3>
                        <a className="button" href={props.link} aria-label="Find out more about TDS Charitable Foundation privacy policy" target='_blank' rel="noopener noreferrer">Find out more</a>
                    </>
                )
            }
                break;
            case 'contact': {
                return (
                    <>
                        <p className='description text-normal white col-12 col-md-8 col-lg-6'>Got a question or suggestion for us? Get in touch with the TDS Charitable Foundation.</p>
                        <div className='d-flex contact justify-content-start flex-column flex-lg-row '>
                            <div className='contactPrt1'>
                                <div className='section1 section'>
                                    <p className='description email text-normal white col-12 mb-0'>Email</p>
                                    <p className='text-normal white col-12 mb-0'>
                                        <a href='mailto:info@tdsfoundation.org.uk' aria-label="Email TDS Charitable Foundation at info@tdsfoundation.org.uk" style={{ color: "#fff", display: 'inline-block' }}>info@tdsfoundation.org.uk</a>
                                    </p>
                                </div>
                                <div className='section2 section'>
                                    <p className='description phone text-normal white col-12 mb-0'>Phone</p>
                                    <p className=' text-normal white col-12 mb-0'>020 000 0000</p>
                                    <p className=' text-normal white col-12 mb-0'>Lines open 9am - 5pm, Mon to Fri</p>
                                </div>
                            </div>
                            <div className='contactPrt2'>
                                <div className='section1 section'>
                                    <p className='description post text-normal white col-12 mb-0'>Post</p>
                                    <p className=' text-normal white col-12 col-mb-4 mb-0'>TDS Charitable Foundation
                                        West Wing, First Floor,
                                        The Maylands Building,
                                        200 Maylands Avenue,
                                        Hemel Hempstead,
                                        HP2 7TG </p>
                                </div>
                            </div>
                        </div>

                    </>
                )
            }
        }
    }


    return (

        <div className="hero bg-blue">
            <div className='container'>
                <div className='content-container'>
                    {props.title ? (
                        props.page === 'homepage' ? (
                            <h1 className='title white col-12 col-md-7 col-lg-5'>{props.title}</h1>
                        ) : props.page === 'about' ? (
                            <h1 className='title about-title white col-12 col-md-9 col-lg-9'>{props.title}</h1>
                        ) : (
                            <h3 className='title white col-12 col-md-7 col-lg-5'>{props.title}</h3>
                        )
                    ) : null}
                    {__renderHeroDescription(props.page)}

                </div>
            </div>
        </div>

    )
}

export default HeroSection
